import React, { useEffect, useRef } from "react";
import styled from 'styled-components';
import { useDispatch, useSelector } from "react-redux";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import Header from '../../components/common/header/Header';
import Footer from "../../components/common/Footer";
import LoadingOverlay from 'react-loading-overlay';
import { Redirect, useHistory } from 'react-router-dom';
import CustomTitle from "../../components/common/title/CustomTitle";
import NormalInput from "../../components/common/input/NormalInput";
import { useState } from "react";
import CheckBoxInput from "../../components/common/input/CheckBoxInput";
import NormalBtn from "../../components/common/button/NormalBtn";
import { loginAction, restLoginErrorAction, resetRegStatusAction } from "../../modules/su/userModule";
import { reqEsApplyAction } from "../../modules/es/esApplyModule";
import { Link } from "react-router-dom";
import { render } from "@testing-library/react";
import { getUserCartAction } from "../../modules/su/userCartModule";
import $ from 'jquery';
import {isMobileOnly} from 'react-device-detect';

/**
 * 로그인 화면
 */
const SiLoginBlock = styled.div`
    width: 100%;
    margin: 0 auto;
    ${!isMobileOnly&&"padding-top: 80px"};
`;

const SiLoginContentsBlock = styled.div`
    padding: ${isMobileOnly?"25px 0":"90px 0 120px"};
    background-color: #f4f4f4;
`;

const SiLoginContentsBoxBlock = styled.div`
     width: ${isMobileOnly?'100%':'520px'};
     padding: 50px ${isMobileOnly?'20px':'60px'};
    
    margin: 0 auto;
    background-color: #fff;
    border-radius: 6px;
`;

const SiLoginPopupHeaderBlock = styled.div`
    position: relative;
    .title {
        font-size: 20px;
        font-weight: normal;
        line-height: 1.44;
        text-align: left;
        color: #111111;
    }

    .close_btn {
        margin-top: 22px;
        margin-left: 745px;
        width: 36px;
        height: 36px;
        background: url(/assets/images/icon/popup_heade_close-icon.png) center center/auto no-repeat;
        margin-bottom: 12px;
        background-size: 15px 15px;
        position: absolute;
        top: -28px;
        right: -7px;
    }
`;

const SiLoginSpanBlock = styled.span`
    display: ${props => props.dispError ? 'block' : 'none'};
    margin-top: 5px;
    margin-left: 30px;
    line-height: 20px;
    font-size: 12px;
    color: #f80053;
`;

const SiLoginDivBlock = styled.div`
    text-align: center;
`;

const SiLoginUlBlock = styled.ul`
    display: inline-block;
`;

const SiLoginLiBlock = styled.li`
    ${isMobileOnly?`
    font-size: 13px; 
    line-height: 1.69;
    color: #999999;
    `:`
    font-size: 14px;
    color: #999999;
    `};

    
    float: left;

    ${isMobileOnly?`
    ::after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 13px;
        margin: 0 6px;
        background-color: #cccccc;
        position: relative;
        top: 2px;
    }

    :last-child::after {
        display: none;
    }
    `:`
    ::after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 13px;
        margin: 0 18px;
        background-color: #8a8d8f;
    }

    :last-child::after {
        display: none;
    }
    `};

    
`;

const SiLoginMBlock = styled.div`
    width: 100%;
    margin: 0 auto;
    background-color: #ffffff;

    .header-block {
        width: 100vw;
        
        height: 50px;
        background-color: #ffffff;
        position: relative;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: #111111;
        line-height: 50px;

        .back {
            width: 36px;
            height: 36px;
            position: absolute;
            top: 7px;
            left: 2px;
            background: url(/assets/images/icon/back_btn.svg) center center/auto no-repeat;
        }
    }
`;

const SiLoginMContentsBlock = styled.div`
    margin: 0 4vw;

    .title {
        font-size: 18px;
        font-weight: normal;
        line-height: 1.44;
        text-align: left;
        color: #111111;
    }
`;

const SiLoginMErrBlock = styled.div`
    display: ${props => props.dispError ? 'block' : 'none'};
    line-height: 16px;
    ${isMobileOnly?`
    font-size: 12px; 
    `:`
    font-size: 14px;
    `};
    color: #fc1c67;
    font-weight: normal;
    line-height: 1.37;
    letter-spacing: -0.7px;
    margin-bottom: 17px;
    padding-top: 3px;

    ::before {
        content: '';
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 7px;
        background: url(/assets/images/icon/error-icon.png) center center/cover no-repeat;
        vertical-align: -3px;
    }
`;

const SiLogin = ({ usePopUp = false , onClosePopup}) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [email, setEmail] = useState(null);
    const [passwd, setPasswd] = useState(null);

    const [emailErr, setEmailErr] = useState(false);
    const [emailErrTxt, setEmailErrTxt] = useState("");

    const [passwdErr, setPasswdErr] = useState(false);
    const [passwdErrTxt, setPasswdErrTxt] = useState("");

    const [keepLogin, setKeepLogin] = useState(false);

    const refPassword = useRef(null);
    const [inputType, setInputType] = useState("password");

    const { error, loading, accessToken, loginError, esApplyInfo } = useSelector(
        ({ userReducer, loadingReducer, esApplyReducer }) => ({
            error: userReducer.loginError,
            loading: loadingReducer['user/LOGIN'],
            accessToken: userReducer.accessToken,
            loginError: userReducer.loginError,
            esApplyInfo: esApplyReducer.esApplyInfo,
        })
    );

    useEffect(() => {

        if (!usePopUp) {
            dispatch(setCurMenuAction('login'));
            dispatch(setHeaderTransferAction(false));
        }


        if (loginError !== null) {
            if (loginError.code === 300) {
                setEmailErr(true);
                setEmailErrTxt(loginError.message);
            } else if (loginError.code === 400) {
                setPasswdErr(true);
                setPasswdErrTxt(loginError.message);
            }
        }

        // Error 상태 초기화
        dispatch(restLoginErrorAction());
        dispatch(resetRegStatusAction());

        if (usePopUp !== true) {
            window.scrollTo(0, 0);
        }
    }, [error, loading, loginError]);

    useEffect(() => {
        // 로그인 완료하면 홈으로 이동
        if (!error && accessToken !== null && accessToken.length > 0) {

            if (usePopUp === true) {
                dispatch(getUserCartAction())
                //데이터 반환 시, reset 됨.
                return ;
            }

            // 장바구니 가져오기
            dispatch(getUserCartAction())

            //#2530 history back 위치 저장되어 있는 경우 처리
            if(history && history.location && history.location.state && history.location.state.from){
                return history.replace(history.location.state.from);
            }
            return history.push('/');
        }
    }, [accessToken])

    //패스워드 입력창 눈 나오게 수정.
    const handleViewpassword = () => {
        if($("#viewPass").hasClass('active')){
            setInputType("password")
            $("#viewPass").removeClass('active');
        }
        else {
            setInputType("text");
            $("#viewPass").addClass('active');
        }
    }

    useEffect(() => {
        if(isMobileOnly) {
            return;
        }
        if (refPassword.current) {
            return;
            const el = refPassword.current;
            if($("#viewPass").length < 1){
                $(el).after("<button type='button' class='input_item view_password-btn' id='viewPass' style='position: absolute;'></button>");
                $("#viewPass").on("click", handleViewpassword);
            }

        }
    }, [refPassword])

    const handleEmailInput = (e) => {
        // console.log("email value : " + e.target.value);
        setEmail(e.target.value);
        setEmailErr(false);
        setEmailErrTxt("");
    }

    const handlePasswdInput = (e) => {
        // console.log("passwd value : " + e.target.value);
        setPasswd(e.target.value);
        setPasswdErr(false);
        setPasswdErrTxt("");
    }

    const handleKeepLogin = (value) => {
        setKeepLogin(value);
    }

    // 로그인 하기
    const handleSubmit = () => {
        if (!email) {
            setEmailErr(true);
            setEmailErrTxt("이메일을 입력해 주세요.");
            return;
        }

        if (!passwd) {
            setPasswdErr(true);
            setPasswdErrTxt("비밀번호를 입력해 주세요.");
            return;
        }

        setEmailErr(false);
        setEmailErrTxt("");
        setPasswdErr(false);
        setPasswdErrTxt("");

        dispatch(loginAction(email, passwd));
    }

    //#2575 로그인 엔터키 처리 추가
    const handleEnterKeyPress = () => {
        handleSubmit();
    }

    const handleBack = () => {
        if(history && history.location && history.location.state && history.location.state.from){
            return history.replace(history.location.state.from);
        }
        
        history.goBack();
    }

    const handlePopupClose = () => {
        if(onClosePopup !== null && onClosePopup !== undefined) {
            onClosePopup();
        }
    }

    const getErrText = () => {
        if(emailErr) {
            return emailErrTxt;
        }

        if(passwdErr) {
            return passwdErrTxt;
        }
    }
    return (
        !usePopUp&&isMobileOnly?
        <SiLoginMBlock>
            <LoadingOverlay
                active={loading}
                spinner
                text=''
            >
                <div className="header-block margin_b-30">
                    <button className="back" onClick={handleBack} />
                    로그인
                </div>
                <SiLoginMContentsBlock>
                    <div className="title margin_b-30">안녕하세요!<br/>어디가구입니다.</div>
                    <NormalInput type='email'
                        maxLength='100'
                        placeholder='이메일 주소를 입력해주세요.'
                        marginBottom='10px'
                        onChange={handleEmailInput}
                        //dispError={emailErr}
                        //errText={emailErrTxt}
                        enterPress={handleEnterKeyPress}
                        spanAlign={'left'}
                            errIcon={true} />
                    <NormalInput inputRef= {refPassword} type={inputType}
                        maxLength='20'
                        placeholder='비밀번호를 입력해주세요.'
                        marginBottom='17px'
                        onChange={handlePasswdInput}
                        //dispError={passwdErr}
                        //errText={passwdErrTxt}
                        enterPress={handleEnterKeyPress}
                        spanAlign={'left'}
                            errIcon={true} />
                    <SiLoginMErrBlock className="margin_b-20" dispError={emailErr || passwdErr}>{getErrText()}</SiLoginMErrBlock>
                    <CheckBoxInput title="로그인 상태 유지"
                    onClick={handleKeepLogin}
                    defaultValue={keepLogin}
                    margin="0px 0px 0px -4px"
                    labelmargin="0px 0px 0px 10px"  />
                    <NormalBtn width="100%"
                            lineHeight="52px"
                            textColor="#111111"
                            bgColor="#ffc742"
                            height="52px" borderRadius="4px"
                            fontSize="16px" fontWeight="500"
                            marginBottom="20px" marginTop="27px" float="none"
                            text="로그인하기"
                            onClick={handleSubmit} />
                    <SiLoginDivBlock>
                        <SiLoginUlBlock>
                            <SiLoginLiBlock><Link to="/findid">아이디찾기</Link></SiLoginLiBlock>
                            <SiLoginLiBlock><Link to="/resetpw">비밀번호 재설정</Link></SiLoginLiBlock>
                            <SiLoginLiBlock><Link to='/register'>회원가입</Link></SiLoginLiBlock>
                        </SiLoginUlBlock>
                    </SiLoginDivBlock>
                </SiLoginMContentsBlock>
                
            </LoadingOverlay >
        </SiLoginMBlock>
        :
        <SiLoginBlock>
        {
            usePopUp? 
            <LoadingOverlay
                active={loading}
                spinner
                text=''
            >
                <SiLoginContentsBlock style={{padding:"0px", backgroundColor:'transparent'}}>
                    <SiLoginContentsBoxBlock>
                        <SiLoginPopupHeaderBlock>
                        <div className="title margin_b-30">안녕하세요!<br/>어디가구입니다.</div>
                        <button className="close_btn" onClick={handlePopupClose}></button>
                        </SiLoginPopupHeaderBlock>
                        
                        <NormalInput type='email'
                        maxLength='100'
                        placeholder='이메일 주소를 입력해주세요.'
                        marginBottom='10px'
                        onChange={handleEmailInput}
                        //dispError={emailErr}
                        //errText={emailErrTxt}
                        enterPress={handleEnterKeyPress}
                        spanAlign={'left'}
                            errIcon={true} />
                        <NormalInput inputRef= {refPassword} type={inputType}
                        maxLength='20'
                        placeholder='비밀번호를 입력해주세요.'
                        marginBottom='17px'
                        onChange={handlePasswdInput}
                        //dispError={passwdErr}
                        //errText={passwdErrTxt}
                        enterPress={handleEnterKeyPress}
                        spanAlign={'left'}
                            errIcon={true} />
                        <SiLoginMErrBlock className="margin_b-20" dispError={emailErr || passwdErr}>{getErrText()}</SiLoginMErrBlock>
                        
                        <CheckBoxInput title="로그인 상태 유지"
                            onClick={handleKeepLogin}
                            defaultValue={keepLogin}
                            margin="0px 0px 0px -4px"
                            labelmargin="0px 0px 0px 10px"  />
                        <NormalBtn width="100%"
                            lineHeight="58px"
                            textColor="#111"
                            bgColor="#ffc742"
                            height="60px" borderRadius="30px"
                            fontSize="22px" fontWeight="500"
                            marginBottom="20px" marginTop="30px" float="none"
                            text="로그인하기"
                            onClick={handleSubmit} />

                        <SiLoginDivBlock>
                            <SiLoginUlBlock>
                                <SiLoginLiBlock><Link to="/findid">아이디찾기</Link></SiLoginLiBlock>
                                <SiLoginLiBlock><Link to="/resetpw">비밀번호 재설정</Link></SiLoginLiBlock>
                                <SiLoginLiBlock><Link to='/register'>회원가입</Link></SiLoginLiBlock>
                            </SiLoginUlBlock>
                        </SiLoginDivBlock>

                    </SiLoginContentsBoxBlock>
                </SiLoginContentsBlock>
            </LoadingOverlay >
            :
            <LoadingOverlay
                active={loading}
                spinner
                text=''
            >
                <Header usePopUp={usePopUp} />
                <SiLoginContentsBlock style={usePopUp ? {padding:"0px", backgroundColor:'transparent'} : {}}>
                    <SiLoginContentsBoxBlock>
                        <CustomTitle title="로그인" textColor="#111" />
                        <NormalInput type='email'
                            maxLength='100'
                            placeholder='이메일 주소를 입력해주세요.'
                            marginBottom='10px'
                            onChange={handleEmailInput}
                            dispError={emailErr}
                            errText={emailErrTxt}
                            enterPress={handleEnterKeyPress}
                            spanAlign={'center'}
                                errIcon={true} />
                        <NormalInput inputRef= {refPassword} type={inputType}
                            maxLength='20'
                            placeholder='비밀번호를 입력해주세요.'
                            marginBottom='10px'
                            onChange={handlePasswdInput}
                            dispError={passwdErr}
                            errText={passwdErrTxt}
                            enterPress={handleEnterKeyPress}
                            spanAlign={'center'}
                                errIcon={true} />
                        <CheckBoxInput title="로그인 상태 유지"
                            onClick={handleKeepLogin}
                            defaultValue={keepLogin}
                            labelmargin="0px 0px 0px 10px"  />
                        <SiLoginSpanBlock dispError={emailErr || passwdErr}>{}</SiLoginSpanBlock>

                        <NormalBtn width="100%"
                            lineHeight="58px"
                            textColor="#111"
                            bgColor="#ffc742"
                            height="60px" borderRadius="30px"
                            fontSize="22px" fontWeight="500"
                            marginBottom="20px" marginTop="40px" float="none"
                            text="로그인하기"
                            onClick={handleSubmit} />

                        <SiLoginDivBlock>
                            <SiLoginUlBlock>
                                <SiLoginLiBlock><Link to="/findid">아이디찾기</Link></SiLoginLiBlock>
                                <SiLoginLiBlock><Link to="/resetpw">비밀번호 재설정</Link></SiLoginLiBlock>
                                <SiLoginLiBlock><Link to='/register'>회원가입</Link></SiLoginLiBlock>
                            </SiLoginUlBlock>
                        </SiLoginDivBlock>

                    </SiLoginContentsBoxBlock>
                </SiLoginContentsBlock>
                <Footer usePopUp={usePopUp} />
            </LoadingOverlay >
        }
        </SiLoginBlock>

    );
};

export default SiLogin;
